import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { Pages } from '../types/pages.enum';

@Injectable({
  providedIn: 'root',
})
export class ActivePageService {
  replaySubject: ReplaySubject<Pages>;

  constructor() {
    // Creations
    this.replaySubject = new ReplaySubject(1);
  }

  // Fire
  setActivePage(activePage: Pages) {
    this.replaySubject.next(activePage);
  }

  // On
  getObservable() {
    return this.replaySubject;
  }
}
